module.exports = __webpack_public_path__ + "img/ski_sub_title5m.9c23abe3.jpg";